// Mock data for e-commerce demo

export const products = [
  {
    id: 1,
    name: "Koszulka Premium",
    description: "Wysokiej jakości koszulka z bawełny organicznej",
    price: 149.99,
    image: "https://images.unsplash.com/photo-1759572095384-1a7e646d0d4f",
    category: "clothing"
  },
  {
    id: 2,
    name: "Koszulka Basic",
    description: "Wygodna koszulka na co dzień",
    price: 99.99,
    image: "https://images.unsplash.com/photo-1562157873-818bc0726f68",
    category: "clothing"
  },
  {
    id: 3,
    name: "Bluza Streetwear",
    description: "Stylowa bluza z kapturem w miejskim stylu",
    price: 299.99,
    image: "https://images.unsplash.com/photo-1553539516-93a847a1e8cf",
    category: "clothing"
  },
  {
    id: 4,
    name: "Bluza Oversize",
    description: "Komfortowa bluza oversize",
    price: 279.99,
    image: "https://images.unsplash.com/photo-1564557287817-3785e38ec1f5",
    category: "clothing"
  },
  {
    id: 5,
    name: "Buty Sportowe Classic",
    description: "Wygodne buty do biegania i treningu",
    price: 399.99,
    image: "https://images.unsplash.com/photo-1608667508764-33cf0726b13a",
    category: "footwear"
  },
  {
    id: 6,
    name: "Buty Sportowe Premium",
    description: "Ekskluzywne buty sportowe",
    price: 499.99,
    image: "https://images.pexels.com/photos/7674491/pexels-photo-7674491.jpeg",
    category: "footwear"
  },
  {
    id: 7,
    name: "Zestaw Akcesoriów",
    description: "Elegancki zegarek i inne dodatki",
    price: 599.99,
    image: "https://images.unsplash.com/photo-1774653273863-a689ee748eee",
    category: "accessories"
  },
  {
    id: 8,
    name: "Torebka Designer",
    description: "Stylowa torebka ze skóry ekologicznej",
    price: 449.99,
    image: "https://images.pexels.com/photos/5658861/pexels-photo-5658861.jpeg",
    category: "accessories"
  }
];

export const features = [
  {
    title: "Przejrzysty katalog produktów",
    description: "Łatwe przeglądanie i wyszukiwanie produktów"
  },
  {
    title: "Optymalizacja pod mobile",
    description: "Idealny wygląd na wszystkich urządzeniach"
  },
  {
    title: "Prosty proces zakupu",
    description: "Szybka ścieżka od produktu do zamówienia"
  },
  {
    title: "Gotowy pod reklamy",
    description: "Zoptymalizowany pod kampanie Facebook i Google"
  },
  {
    title: "Nowoczesny design",
    description: "Elegancki wygląd zwiększający konwersję"
  }
];

export const goals = [
  "Zwiększenie sprzedaży online",
  "Lepsza prezentacja produktów",
  "Prosty i szybki zakup",
  "Przyciąganie klientów z reklam"
];

export const contactInfo = {
  telegram: "@srwebstudio",
  whatsapp: "+48452688251",
  email: "webstudiosr4@gmail.com",
  facebook: "https://www.facebook.com/share/18bDjbVQWD/"
};

// Mock cart functionality
let cart = [];

export const addToCart = (product) => {
  const existingItem = cart.find(item => item.id === product.id);
  if (existingItem) {
    existingItem.quantity += 1;
  } else {
    cart.push({ ...product, quantity: 1 });
  }
  return cart;
};

export const removeFromCart = (productId) => {
  cart = cart.filter(item => item.id !== productId);
  return cart;
};

export const updateQuantity = (productId, quantity) => {
  const item = cart.find(item => item.id === productId);
  if (item) {
    item.quantity = quantity;
  }
  return cart;
};

export const getCart = () => cart;

export const getCartTotal = () => {
  return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
};

export const clearCart = () => {
  cart = [];
  return cart;
};
